import { useContext, useEffect, useRef, useState, useMemo } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { DataGrid } from "@mui/x-data-grid";
import { Modal, Box } from "@mui/material";
import { PedidosDetalleContext } from '../../../../context/pedidosdetalle/PedidosDetalleContext';
import { Paginator } from '../../../../components/paginator/Paginator';
import CircularProgress from "@mui/material/CircularProgress";
import useDocumentTitle from "../../../../components/Title";
import ArticulosModal from '../../../articulos/articulosModal/articulosModal';
import { headers } from "./configGrid/headers";
import { formatRows } from "./configGrid//rows";
import { indice } from "../../../../components/DataGrid/indice";
import { getActionColumn } from "../../../../components/ActionesColumns/ActionColumns";
import FormDetalle from './formDetalle/formDetalle';
import { PedidosDetalleFormState } from '../../../../context/pedidosdetalle/PedidosDetalleFormState';
import ConfirmDialog from "../../../../components/dialogs/DeleteDialog";
import ErrorDialog from "../../../../components/dialogs/ErrorDeleteDialog";
import { fetchEntityData, deleteItem } from './configGrid/apiCalls';

export const DatatableDetalle = ({ pedidoid, catcli, actualizaTotalPedido, estadoEdicionPedido }) => {

  const titleGrid = "Articulos en el Pedido"
  useDocumentTitle(titleGrid);
  const navigate = useNavigate();
  const nameData = "pedidos";
  const contexto = useContext(PedidosDetalleContext);
  const { getPedidosDetallePanelData, deletePedidosDetalleData,
    getPedidosDetalleByIdData } = contexto;

  // Estado para Datos y Paginacion
  const [listaItems, setListaItems] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  // Estado para Loading
  const [isLoading, setIsLoading] = useState(false);
  // Estados para la paginación
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [numPagina, setNumPagina] = useState(1);
  const [filas, setFilas] = useState(isMobile ? 20 : 100);
  // Estado del buscador
  const [searchOca, setSearchOca] = useState();
  const [searchIdArt, setSearchIdArt] = useState();
  const isFetchingRef = useRef(false);
  // Estado para un modal de observacion
  const [observacionSeleccionada, setObservacionSeleccionada] = useState("");
  const [modalObsOpen, setModalObsOpen] = useState(false);
  // Estado para el Modal de confirmación
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  // Estado para el modal de detalle
  const [isModalDetalleOpen, setIsModalDetalleOpen] = useState(false);
  // Estado para manejar el error
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);

  const getData = getPedidosDetallePanelData;
  const deleteData = deletePedidosDetalleData;
  const findOne = getPedidosDetalleByIdData;

  useEffect(() => {
    const parsed = Number(pedidoid);

    if (!isNaN(parsed)) {
      setSearchOca(parsed);
    }
  }, [pedidoid]);

  useEffect(() => {
    fetchData();
  }, [searchOca, searchIdArt, numPagina, filas]);


  const fetchData = async () => {
    if (isFetchingRef.current) return; // Evita múltiples llamadas simultáneas
    isFetchingRef.current = true;
    setIsLoading(true);

    try {
      const data = await getData(pedidoid, searchIdArt, numPagina, filas);
      if (data) {
        setListaItems(data.orderCacheDetails || []);
        setTotalItems(data.pagination.totalItems || 0);
      }
    } catch (error) {
      console.error("Error al cargar sliders:", error);
    } finally {
      setIsLoading(false);
      isFetchingRef.current = false;
    }
  };

  const handleSelectArticulo = (artId) => {
    setSearchIdArt(artId); // Guardar el id del artículo seleccionado // Actualizar el formulario con los valores seleccionados
  };

  const handleOpenModalObs = (texto) => {
    setObservacionSeleccionada(texto);
    setModalObsOpen(true);
  };

  const handleCloseModalObs = () => {
    setModalObsOpen(false);
  };

  const openModal = (id) => {
    setSelectedItem(id);

    setIsModalOpen(true);
  };
  const handleOpenDetalleModal = () => {
    setIsModalDetalleOpen(true);
  };
  const handleCloseDetalleModal = async () => {
    await fetchData()
    setIsModalDetalleOpen(false);
    setSelectedItem(null);
  };
  const closeModal = () => {
    setSelectedItem(null);
    setIsModalOpen(false);
  };

  const closeErrorDialog = () => {
    setErrorMessage(""); // Limpia el mensaje de error
    setIsErrorDialogOpen(false); // Cierra el diálogo de error
  };

  const handleClickEdit = async (id) => {
    try {
      setSelectedItem(id)
      // Abre el modal después de cargar los datos en selectedRow
      handleOpenDetalleModal();
    } catch (error) {
      console.error("Error al obtener detalles:", error);
    }
  };
  const handleDelete = async () => {
    try {
      await deleteItem(deleteData, selectedItem, findOne);
      await fetchData(); // Refresca los datos
      actualizaTotalPedido();
      closeModal(); // Cierra el modal de confirmación
    } catch (error) {
      console.error(error);
      setErrorMessage("No se pudo eliminar el elemento. Inténtalo nuevamente.");
      setIsErrorDialogOpen(true);
    }
  };

  const datosColum = useMemo(() => {
    const columnasBase = [
      ...indice(numPagina, filas),

      ...headers.map((col) => {
        if (col.field === "observacion") {
          return {
            ...col,
            renderCell: (params) => {
              const texto = params.value;
              if (!texto) return null;

              return (
                <button
                  style={{
                    backgroundColor: "#1976d2",
                    color: "#fff",
                    border: "none",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleOpenModalObs(texto)}
                >
                  Ver
                </button>
              );
            },
          };
        }
        return col;
      })
    ];

    if (estadoEdicionPedido === true) {
      columnasBase.push(...getActionColumn(handleClickEdit, openModal));
    }

    return columnasBase;
  }, [
    numPagina,
    filas,
    estadoEdicionPedido,
  ]);



  const rows = useMemo(() => formatRows(listaItems), [listaItems]);

  return (
    <div className="datatable">
      <div className="datatableTitle">
        <h2>{titleGrid}</h2>
        <div className="filterContainer">
          <div className="searchContainer">
            <div className="inputWrapper">
              {rows.length > 10 && (
                <ArticulosModal
                  handleChange={setSearchIdArt}
                  descSelected={"Seleccione"}
                  onSelect={handleSelectArticulo} />
              )}

            </div>
          </div>
          <div className="linkContainer">

          </div>
        </div>
      </div>

      {(isLoading) ? (
        <div className="loading">
          <div style={{ display: "flex", justifyContent: "center", margin: "20px" }}>
            <h1>Cargando datos...</h1>
            <CircularProgress />
          </div>
        </div>
      ) : (
        <>
          {estadoEdicionPedido === true &&
            <button
              type="button"
              className={`link`}
              onClick={handleOpenDetalleModal}
            >
              Agregar
            </button>
          }

          <div className="datagridWrapper">
            <DataGrid
              className="datagrid"
              rows={rows}
              rowHeight={28}
              columns={datosColum}
              pageSize={filas}
              paginationMode="server"
              onPageChange={(newPage) => setNumPagina(newPage + 1)} // Convertir de 0-index a 1-index
              onPageSizeChange={(newPageSize) => {
                setFilas(newPageSize);
                setNumPagina(1); // Reinicia a la primera página si cambia el tamaño de la página
              }}
              rowCount={totalItems}
              hideFooterPagination
              autoHeight
              sx={{
                '& .MuiDataGrid-root': {
                  border: 'none',
                },
                '& .MuiDataGrid-cell': {
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                },
              }}
            />
          </div>
          <div className="paginatorWrapper">
            <Paginator
              numPagina={numPagina}
              setNumPagina={setNumPagina}
              totalPages={Math.ceil(totalItems / filas)}
              filas={filas}
              setFilas={setFilas}
              totalDataItems={totalItems}
            />
          </div>
        </>

      )}
      {modalObsOpen && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
            zIndex: 1000,
            width: "300px",
            position: "fixed",
          }}
        >
          {/* Botón cerrar tipo cruz */}
          <button
            onClick={handleCloseModalObs}
            style={{
              position: "absolute",
              top: "8px",
              right: "8px",
              background: "transparent",
              border: "none",
              fontSize: "20px",
              cursor: "pointer",
            }}
            aria-label="Cerrar"
          >
            ×
          </button>

          <h3>Observación</h3>
          <p>{observacionSeleccionada}</p>
        </div>
      )}

      <PedidosDetalleFormState>
        <Modal
          open={isModalDetalleOpen}
          onClose={handleCloseDetalleModal}
          aria-labelledby="modal-form-detalle"
          aria-describedby="modal-form-detalle-descripcion"
          className="modalOferta"
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              maxWidth: '80%', // Se ajusta para ser responsive
              maxHeight: '80%', // Limitar la altura
              width: '100%', // El ancho ocupará el 100% hasta el máximo
              height: 'auto', // Deja que la altura dependa del contenido
              bgcolor: 'background.paper',
              borderRadius: '8px',
              boxShadow: 24,
              p: 4,
              overflowY: 'auto', // Habilitar scroll vertical

            }}
          >
            <FormDetalle
              iddet={selectedItem}
              pedidoid={pedidoid}
              catcli={catcli}
              closeModal={handleCloseDetalleModal}
              actualizaTotalPedido={actualizaTotalPedido}
            />
          </Box>
        </Modal>

      </PedidosDetalleFormState>

      <ConfirmDialog
        open={isModalOpen}
        onClose={closeModal}
        onConfirm={handleDelete}
        nameData={nameData}
      />
      <ErrorDialog
        open={isErrorDialogOpen}
        onClose={closeErrorDialog}
        errormessages={errorMessage}
      />

    </div>
  );
};

export default DatatableDetalle;
